module.exports = "mutation ($id: ID!, $data: ProductUpdate!) {\n  ProductUpdate(id: $id, data: $data) {\n    id\n    updatedAt\n  }\n}\n"